export * from './ArrowDUturnUpLeftIcon';
export * from './ArrowDUturnUpLeftIcon16Light';
export * from './ArrowDUturnUpLeftIcon16Regular';
export * from './ArrowDUturnUpLeftIcon16Solid';
export * from './ArrowDUturnUpLeftIcon20Light';
export * from './ArrowDUturnUpLeftIcon20Regular';
export * from './ArrowDUturnUpLeftIcon20Solid';
export * from './ArrowDUturnUpLeftIcon24Regular';
export * from './ArrowDUturnUpLeftIcon24Solid';
export * from './ArrowDUturnUpLeftIcon32Regular';
export * from './ArrowDUturnUpLeftIcon64Regular';
